export default __webpack_public_path__ + "932af09520208f64b02bafa6f7f31ef0.jpeg";